import { Outlet } from 'react-router-dom'

import Loading from 'modules/finance/components/Loading'
import WorkspaceCollectionsBootstrap from 'modules/finance/lib/WorkspaceCollectionsBootstrap'

import { useFinancialWorkspacePage } from './useFinancialWorkspacePage'

const RootPage = () => {
  const {
    canSeeFinanceWorkspace,
    canSeeFinanceWorkspacePayroll,
    canAccessOverview,
    canSeeAllCompanyData,
    canSeeFinanceWorkspaceCompensations,
    seePayrollLanding,
    loading,
    error,
  } = useFinancialWorkspacePage()

  if (error) {
    return null
  }

  return (
    <WorkspaceCollectionsBootstrap>
      <Loading loading={loading}>
        <Outlet
          context={{
            canSeeFinanceWorkspace,
            canSeeFinanceWorkspacePayroll,
            canAccessOverview,
            canSeeAllCompanyData,
            canSeeFinanceWorkspaceCompensations,
            seePayrollLanding,
          }}
        />
      </Loading>
    </WorkspaceCollectionsBootstrap>
  )
}

export default RootPage
